module.exports = __webpack_public_path__ + "img/accountBg.2f97536b.png";